import React, { Fragment, Component } from "react";

class Footer extends Component {
    render() {
        return(
            <Fragment>
                <footer className="py-4 bg-light mt-auto">
                    <div className="container-fluid px-4">
                        <div className="d-flex align-items-center justify-content-between small">
                            <div className="text-muted">Copyright &copy; EmpatIA 2023</div>
                        </div>
                    </div>
                </footer>
            </Fragment>
        )
    }
}

export default Footer;